module.exports = __webpack_public_path__ + "img/ES-GA.bd215590.png";